import { UserRole } from '../../enums';

export interface ImpersonationResponseDto {
  impersonationToken: string;
  expirationDate: string; // DateTime as ISO string
  targetUserId: string; // Guid
  targetUserName: string;
  targetUserRole: UserRole;
}
